import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import apiUrl from '../apiUrlConstant';
import LeadList from './DashbordLead';
import Select from 'react-select';

const statusOption = [
    { value: 'active', label: 'Active Lead' },
    { value: 'inactive', label: 'Inactive Lead' }
]

class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            filterData: [],
            leadsDropdown: 'dashboardlead',
            leadType: 'active',
            leadSubtype: '',
            currentStatus: '',
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData() {
        axios.get(`${apiUrl.apiUrl.url}/leads/dashboard?type=${this.state.leadType}`)
            .then(response => {
                this.setState({
                    data: response.data.leads,
                    filterData: response.data.leads[this.state.leadType]
                });
            });
    }

    handleDataChange = (newData) => {
        this.fetchData();
    }

    handleStatusFilterChange = (e) => {
        let status = e.value;
        this.setState({
            leadType: status,
            leadSubtype: '',
            currentStatus: status,
            filterData: this.state.data[status]
        });
    }

    render() {
        return (
            <>
                <div className="parentContainer">
                    <div className="absoluteItemForTopBar">
                        <div className="new_breadcrumbs_design">
                            <ul className="d-flex align-items-center gap-3 p-0 m-0">
                                <li>Lead</li>
                                <li><FontAwesomeIcon icon={faChevronRight} /></li>
                                <li>
                                    <a href="#">Dashboard</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="dashboardMainPage leadDashboardMainPage">
                        { //this.state.filterData && this.state.filterData.length > 0 && (
                            <div className="dropdownWithLeadCard">
                                <Select
                                    value={this.state.status}
                                    defaultValue={
                                        statusOption.filter((val) => val.label === "Active Lead")
                                    }
                                    onChange={this.handleStatusFilterChange}
                                    options={statusOption}
                                    className="basic-single leads-filter-dropdown"
                                    classNamePrefix="leads-filter-dropdown-inner"
                                // menuIsOpen={true}
                                />

                                <span className='vertLine'></span>


                                <div className="cardmain">
                                    {this.state.filterData && this.state.filterData.length > 0 && (
                                    this.state.filterData.map(list => (
                                        <div
                                            className={this.state.leadSubtype == list.id ? "cardInner active" : "cardInner"}
                                            key={list.sub_stage}
                                            onClick={() => {
                                                if(this.state.leadSubtype != list.id){
                                                    this.setState({
                                                        leadSubtype: list.id
                                                    });
                                                }else{
                                                    this.setState({
                                                        leadSubtype: ''
                                                    });
                                                }
                                                
                                            }}
                                        >
                                            <h3>{list.sub_stage !== '' ? list.sub_stage : 'Other'}</h3>
                                            <p>{list.record}</p>
                                        </div>
                                    ))
                                    )}
                                </div>
                            </div>
                        //)
                        }

                        <LeadList
                            type={this.state.leadType}
                            sub_type={this.state.leadSubtype}
                            tablekey={`leadList_${Math.floor(Math.random() * 1000)}`}
                            onDataChange={this.handleDataChange}
                        />
                    </div>
                </div>
            </>
        );
    }
}

export default Dashboard;
